import { createStyles, makeStyles } from "@material-ui/core/styles";
import { HEIGHT_HEADER } from "config/constant";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				background: theme.palette.common.white
			},
			title: {
				fontSize: 16,
				marginTop: 10,
				color: theme.palette.secondary.contrastText
			},
			customInput: {
				border: "1px solid #D9D9D9",
				width: "100%",
				height: 38,
				marginTop: 5,
				borderRadius: 6,
				"& > div > input": {
					padding: "8px 12px",
					fontSize: 18
				},
				"& > div > svg": {
					padding: 6,
					fontSize: 18,
					color: "#999FB5"
				},
				"& > .MuiInput-underline:before": {
					borderBottom: "none",
					content: "none"
				},
				"& > .MuiInput-underline:after": {
					borderBottom: "none",
					content: "none"
				}
			},
			inputError: {
				border: "1px solid #ff0002 !important",
				borderRadius: "6px !important"
			},
			textRemeber: {
				color: theme.palette.primary.contrastText,
				fontSize: 16
			},
			rootForm: {
				padding: 15,
				height: `calc(100vh - ${HEIGHT_HEADER + 30}px )`
			},
			mt15: {
				marginTop: 15
			},
			customCheckbox: {
				display: "flex",
				alignItems: "center",
				justifyContent: "flex-end"
			},
			checked: {
				color: `${theme.palette.secondary.main} !important`
			},
			bodyBtnSubmit: {
				display: "flex",
				justifyContent: "center",
				marginTop: 40,
				flexDirection: "column",
				alignItems: "center"
			},
			textInfo: {
				color: "#E77F06",
				textAlign: "center",
				margin: "5px 0px"
			},
			btnSubmit: {
				background: theme.palette.primary.main,
				color: theme.palette.text.contrastText,
				fontSize: 14,
				textTransform: "capitalize",
				width: 167,
				height: 36,
				borderRadius: 6,
				"&:active": {
					background: theme.palette.primary.main,
					opacity: 0.7
				},
				"&:hover": {
					background: theme.palette.primary.main
				}
			},
			btnCancel: {
				width: 167,
				height: 36,
				marginTop: 10,
				textTransform: "capitalize",
				color: theme.palette.primary.contrastText,
				borderRadius: 6
			},
			iconChangePass: {
				textAlign: "center"
			},
			textError: {
				color: "#FF4D4F",
				fontSize: 14,
				marginTop: 4,
				textAlign: "center",
				fontStyle: "italic"
			},
			textNotiSuccess: {
				color: "#1BAF56",
				fontSize: 12,
				marginTop: 5,
				display: "flex",
				alignItems: "center",
				"& >svg": {
					fontSize: 16,
					marginRight: 3
				}
			},
			textNotiError: {
				color: "#FF4D4F",
				fontSize: 12,
				marginTop: 5,
				display: "flex",
				alignItems: "center",
				"& >svg": {
					fontSize: 16,
					marginRight: 3
				}
			},
			textNoti: {
				color: "#777E96",
				fontSize: 12,
				marginTop: 5
			}
		}),
	{
		name: "ChangePasswordPage",
		index: 1
	}
);

export default useStyles;
